import * as yup from 'yup';

export const formSchema = yup.object({
    role: yup.string().min(1).required(),
});